import React from 'react';
import ComingSoonBanner from '../../components/coming-soon-banner';

export default () => {
    return <ComingSoonBanner />;
}